









































































import { Component, Mixins } from "vue-property-decorator";
import PasswordsMixin from "@/mixins/http/PasswordsMixin";
import DisplayErrors from "@/components/DisplayErrors.vue";
import RequestData from "@/store/types/RequestData";
import { RegisterHttp } from "@/utils/Decorators";
import { showToast } from "@/utils/Toast";

@Component({ components: { DisplayErrors } })
export default class ForgotPassword extends Mixins(PasswordsMixin) {
  private email = "";
  private emailSent = false;
  private error = false;

  @RegisterHttp("forgot") http: RequestData;

  get emailValid() {
    const emailRegExp = new RegExp(
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    );
    return emailRegExp.test(this.email);
  }

  goToLogin() {
    this.$router.push({ name: "login" });
  }

  submit() {
    this.forgotPassword({ email: this.email }, "forgot").then(
      (resp) => {
        this.emailSent = true;
      },
      (err) => {
        this.error = true;
      }
    );
  }
}
